<template>
    <!-- 智能腕卡管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'smartWristList')">
            <div slot="header">
                <a-form :form="form" layout="inline">
                    <a-form-item label="ID查询">
                        <a-input placeholder="请输入腕卡\IC\定位识别ID" v-decorator="['icRecogniseId']" @input="search"></a-input>
                    </a-form-item>
                    <a-form-item label="设备颜色">
                        <a-select allowClear placeholder="请选择" v-decorator="['deviceColor']" >
                            <a-select-option value="1">黄色</a-select-option>
                            <a-select-option value="2">紫色</a-select-option>
                            <a-select-option value="3">红色</a-select-option>
                            <a-select-option value="4">蓝色</a-select-option>
                        </a-select>
                    </a-form-item>
                    <!-- <a-form-item label="人员属性">
                        <a-select allowClear placeholder="请选择" v-decorator="['peopleType']" >
                            <a-select-option value="1">儿童</a-select-option>
                            <a-select-option value="2">大人</a-select-option>
                            <a-select-option value="3">工作人员</a-select-option>
                        </a-select>
                    </a-form-item> -->
                    <!-- <a-form-item label="所属门店">
                        <a-select allowClear placeholder="请选择" v-decorator="['shopId']">
                            <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item> -->
                    <a-form-item label="定位状态">
                        <a-select allowClear placeholder="请选择" v-decorator="['posiStatus']" >
                            <a-select-option value="1">正常</a-select-option>
                            <a-select-option value="0">异常</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="电量状态">
                        <a-select allowClear placeholder="请选择" v-decorator="['electricStatus']" >
                            <a-select-option value="1">正常</a-select-option>
                            <a-select-option value="2">异常</a-select-option>
                            <a-select-option value="0">低电量</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">搜索</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <!-- <div class="mb16">
                    <a-button @click="toDeviceAdd" type="primary" class="mr16" v-if="getBtnByAuth('addSmartWrist')">添加设备</a-button>
                    <a-button @click="exportExcel" v-if="getBtnByAuth('smartWristExport')">导出</a-button>
                </div> -->
                <a-table :scroll="{x:800}" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                    <span slot="peopleType" slot-scope="peopleType">{{['','儿童','大人','工作人员'][peopleType]}}</span>
                    <span slot="deviceColor" slot-scope="deviceColor"><a-tag :color="deviceColorList[deviceColor]">{{deviceColorZn[deviceColor]}}</a-tag></span>
                    <span slot="deviceType" slot-scope="deviceType">{{['','腕带','卡片'][deviceType]}}</span>
                    <span slot="posiStatus" slot-scope="posiStatus"><a-badge :status="posiStatus==1?'success':posiStatus==0?'error':'warning'" />{{['异常','正常'][posiStatus] || '无'}}</span>
                    <span slot="electricStatus" slot-scope="electricStatus"><a-badge :status="electricStatus==1?'success':electricStatus==0?'error':'warning'" />{{['低电量','正常'][electricStatus] || '无'}}</span>
                    <span slot="checkTime" slot-scope="checkTime">{{checkTime || "-"}}</span>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('detailSmartWrist')">
                            <a class="text-primary" @click="toDeviceDetial(row.id)">查看</a>
                        </span>
                        <span v-if="getBtnByAuth('editSmartWrist')">
                            <a-divider type="vertical" />
                            <a class="text-primary" @click="toDeviceEdit(row.id)">编辑</a>
                        </span>
                        <a-popconfirm
                            v-if="getBtnByAuth('deleteSmartWrist')"
                            title="确定将该设备删除吗?"
                            @confirm="deviceDelete(row.id)"
                            >
                            <a-divider type="vertical" />
                            <a class="text-primary">删除</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns = [
        {
            title: "设备ID",
            dataIndex: "id"
        },
        {
            title: "所属门店",
            dataIndex: "shopName"
        },
        {
            title: "最新检测门店",
            dataIndex: "lastAppearedShopName",
            scopedSlots: { customRender: 'checkTime'}
        },
        {
            title: "定位识别ID",
            dataIndex: "posiRecogniseId"
        },
        {
            title: "IC识别ID",
            dataIndex: "icRecogniseId"
        },
        // {
        //     title: "人员属性",
        //     dataIndex: "peopleType",
        //     scopedSlots: { customRender: "peopleType" }
        // },
        {
            title: "设备颜色",
            dataIndex: "deviceColor",
            scopedSlots: { customRender: "deviceColor" }
        },
        // {
        //     title: "设备类型",
        //     dataIndex: "deviceType",
        //     scopedSlots: { customRender: "deviceType" }
        // },
        {
            title: "定位状态",
            dataIndex: "posiStatus",
            scopedSlots: { customRender: "posiStatus" }
        },
        {
            title: "定位最新检测时间",
            dataIndex: "lastPosCheckTime",
            scopedSlots: { customRender: 'checkTime'}
        },
        {
            title: "电量状态",
            dataIndex: "electricStatus",
            scopedSlots: { customRender: "electricStatus" }
        },
        {
            title: "电量最新检测时间",
            dataIndex: "lastBatteryCheckTime",
            scopedSlots: { customRender: 'checkTime'}
        },
        // {
        //     title: "最新检测时间",
        //     dataIndex: "checkTime",
        //     scopedSlots: { customRender: "checkTime" }
        // },
        // {
        //     title: "操作",
        //     key: "action",
        //     scopedSlots: { customRender: "action" }
        // }
    ]
    export default {
        name: "smartWristList",
        data() {
            return {
                columns,
                dataSource: [],
                shopList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                deviceColorList: ['','orange','purple','red','blue'],
                deviceColorZn: ['','黄色','紫色','红色','蓝色'],
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            changeInput(e) {

            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.form.resetFields();
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    this.shopList = res;
                });
            },

            // 获取购票订单列表
            getList() {
                if (!Boolean(this.shopId)) {
                    return false;
                }
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.$api.wrist
                    .deviceList({
                        body: Object.assign(values, 
                        {   
                            shopId: this.shopId,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    });
                });
            },
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.loading = true;
                    this.$api.wrist.deviceExport({
                            body: Object.assign(values, {
                                shopId: this.shopId,
                                pageNum: 1,
                                pageSize: 99999999
                            })
                        },
                        {
                            responseType: "blob"
                        })
                        .then(res => {
                            let a = document.createElement("a");
                            let blob = new Blob([res.data], {
                                type: "application/vnd.ms-excel"
                            });

                            this.downloadUrl = window.URL.createObjectURL(blob);

                            let name = '智能腕卡列表-' + this.$moment().format('YYYY/MM/DD') + '.xls'

                            a.setAttribute("href", this.downloadUrl);

                            var reportName = decodeURI(name);

                            a.setAttribute("download", reportName);
                            a.click();
                            this.loading = false
                        });
                });
            },
            toDeviceAdd() {
                this.$router.push({
                    name: 'addSmartWrist'
                })
            },
            toDeviceDetial(id) {
                this.$router.push({
                    name: 'detailSmartWrist',
                    query: {id:id}
                })
            },
            toDeviceEdit(id) {
                this.$router.push({
                    name: 'editSmartWrist',
                    query: {id:id}
                })
            },
            deviceDelete(id) {
                this.$api.wrist
                .deviceDelete({
                    params: {id:id}
                })
                .then(res => {
                    this.getList()
                    this.$message.success('操作成功')
                });
            }
        },
        created() {},
        mounted() {
            this.getShopList()
            this.getList()
        },
        watch: {
            '$route'(val) {
                val.name == 'smartWristList' && this.getList();
            },
            'shopId'(val) {
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
</style>